import React from "react";
import { Col, Row, Container } from "reactstrap";
import { Logo } from "../../components/logo/Logo";
import Footer from "../../layout/footer/Footer";
import LogoDark from "../../images/texpert-logo.png";
import LogoLight from "../../images/texpert-logo-dark.png";

const FooterThree = (props) => {
  return (
    <Footer
      className={props.className && props.className}
      id={props.id && props.id}
    >
      <Container>
        <Row className="g-3 align-items-center">
          <Col md="3">
            <div className="footer-logo">
              <Logo to="/" dark={LogoDark} light={LogoLight} />
            </div>
          </Col>
          <Col md="9" className="d-flex justify-content-md-end">
            <div className="text-base">
              &copy; {new Date().getFullYear()} TEXpert AI Ltd.
            </div>
          </Col>
        </Row>
      </Container>
    </Footer>
  );
};

export default FooterThree;
